import { useReducer } from "react";
import forestData from "../assets/data/forestData.json";

import forEach from "lodash/forEach";
import sortBy from "lodash/sortBy";
import indexOf from "lodash/indexOf";
import some from "lodash/some";
import filter from "lodash/filter";
import join from "lodash/join";

import AppContext from "./appContext";

const getSearchData = (stateFilter) => {
    let searchData = [];
    forEach(forestData, (v, k) => {
        if (!stateFilter || stateFilter.value === "" || indexOf(v.states, stateFilter.value) > -1) {
            let countyNames = v.counties.map((county) => county.name);
            countyNames.sort();
            let desc = join(countyNames, ", ");
            searchData.push({
                id: k,
                label: v.name,
                desc: desc,
            });
        }
    });
    return sortBy(searchData, "label");
};

const initialState = {
    isStartScreenVisible: true,
    isSearchFocusedOnce: false,
    mapExtent: null,
    stateFilter: { value: "", label: "Any State" },
    searchData: getSearchData(null),
    selectedGeos: [],
    searchFeature: null,
    popupContent: null,
    hoveredFeatureProps: null,
    highlightedGeo: null,
    benchmarkGeo: { id: "0", label: "United States" },
    isMapLoading: true,
    isDownloadModalOpen: false,
};

const actions = {
    SET_SEARCH_FEATURE_TO: "SET_SEARCH_FEATURE_TO",
    SET_STATE_FILTER_TO: "SET_STTATE_FILTER_TO",
    REMOVE_GEO: "REMOVE_GEO",
    ADD_GEO: "ADD_GEO",
    CLEAR_GEOS: "CLEAR_GEOS",
    SET_POPUP_CONTENT: "SET_POPUP_CONTENT",
    SET_HOVERED_FEATURE_PROPS: "SET_HOVERED_FEATURE_PROPS",
    SET_HIGHLIGHTED_GEO: "SET_HIGHLIGHTED_GEO",
    SET_BENCHMARK_TO: "SET_BENCHMARK_TO",
    RETURN_TO_START: "RETURN_TO_START",
    SET_SEARCH_FOCUSED: "SET_SEARCH_FOCUSED",
    SET_IS_LOADING: "SET_IS_LOADING",
    SET_MAP_EXTENT: "SET_MAP_EXTENT",
    SET_IS_DOWNLOAD_MODAL_OPEN: "SET_IS_DOWNLOAD_MODAL_OPEN",
};

const AppProvider = ({ children, storybookState }) => {
    const [state, dispatch] = useReducer(
        appReducer,
        storybookState ? { ...initialState, ...storybookState } : initialState
    );

    return (
        <AppContext.Provider
            value={{
                state,
                dispatch,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

const appReducer = (state, action) => {
    let selectedGeos;
    switch (action.type) {
        case actions.SET_SEARCH_FEATURE_TO:
            return {
                ...state,
                isStartScreenVisible: false,
                mapExtent: forestData[action.to.id].extent,
                searchFeature: action.to,
                selectedGeos: forestData[action.to.id].counties.map((county) => {
                    return makeGeo(county.id, county.name, "county");
                }),
            };
        case actions.SET_IS_LOADING:
            return {
                ...state,
                isMapLoading: false,
            };

        case actions.SET_STATE_FILTER_TO:
            return {
                ...state,
                stateFilter: action.to,
                searchData: getSearchData(action.to),
            };
        case actions.REMOVE_GEO:
            selectedGeos = filter(state.selectedGeos, (geo) => geo.id !== action.id);
            return {
                ...state,
                selectedGeos: selectedGeos,
                highlightedGeo: null,
            };
        case actions.ADD_GEO:
            //check to make sure the
            if (some(state.selectedGeos, { id: action.id })) return { ...state };
            selectedGeos = state.selectedGeos.concat(makeGeo(action.id, action.name, "county"));
            return {
                ...state,
                selectedGeos: selectedGeos,
            };
        case actions.CLEAR_GEOS:
            selectedGeos = [];

            return {
                ...state,
                selectedGeos: selectedGeos,
            };
        case actions.SET_POPUP_CONTENT:
            return {
                ...state,
                popupContent: action.content,
            };
        case actions.SET_HOVERED_FEATURE_PROPS:
            return {
                ...state,
                hoveredFeatureProps: action.hoveredFeatureProps,
            };
        case actions.SET_HIGHLIGHTED_GEO:
            return {
                ...state,
                highlightedGeo: action.to ? { id: action.to, geo_level: "county" } : null,
            };
        case actions.SET_BENCHMARK_TO:
            return {
                ...state,
                benchmarkGeo: action.to,
            };
        case actions.SET_SEARCH_FOCUSED:
            return {
                ...state,
                isSearchFocusedOnce: true,
            };
        case actions.RETURN_TO_START:
            return {
                ...state,
                isStartScreenVisible: true,
                isSearchFocusedOnce: false,
            };
        case actions.SET_MAP_EXTENT:
            return {
                ...state,
                mapExtent: action.to,
            };
        case actions.SET_IS_DOWNLOAD_MODAL_OPEN:
            return {
                ...state,
                isDownloadModalOpen: action.to,
            };
        default:
            throw new Error();
    }
};

function makeGeo(id, name, geoLevel) {
    return {
        id: id,
        label: name,
        name: name,
        geoLevel: geoLevel,
    };
}

export { actions, AppProvider };
